export default {
  components: {
  },
  props: ['type'],
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
};
